// extracted by mini-css-extract-plugin
export default {"languageSwitcher":"LanguageSwitcher_languageSwitcher__zm7gW","langButton":"LanguageSwitcher_langButton__WeE+P","active":"LanguageSwitcher_active__wcvyc"};